import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material'
import React from 'react'
import './EshopCustomerInfo.scss'
import DemoCardForm from './DemoCardForm'
export type ShippingType = 'courier' | 'storePickup'
export type PaymentType = 'cod' | 'bankTransfer' | 'card'
import {useState} from 'react';

export interface EshopCustomerInfoData {
  name: string
  surname: string
  email: string
  phone: string
  address: string
  city: string
  zipcode: string
  shipping: ShippingType
  payment: PaymentType
}

interface EshopCustomerInfoProps {
    data: EshopCustomerInfoData;
    setData: React.Dispatch<
        React.SetStateAction<EshopCustomerInfoData>
    >;
  
}
export default function EshopCustomerInfo({
  data,
  setData,

}: EshopCustomerInfoProps) {

  const handleChange = (
    field: keyof EshopCustomerInfoData,
    value: string
  ) => {
    setData(prev => ({
      ...prev,
      [field]: value,
    }))
  }

  return (
    <div className="eshopCustomerInfo">

      <div className="eci-field">
        <label htmlFor="name">Όνομα:</label>
        <TextField
          id="name"
          value={data.name}
          onChange={(e) => handleChange('name', e.target.value)}
          fullWidth
        />
      </div>

      <div className="eci-field">
        <label htmlFor="surname">Επώνυμο:</label>
        <TextField
          id="surname"
          value={data.surname}
          onChange={(e) => handleChange('surname', e.target.value)}
          fullWidth
        />
      </div>

      <div className="eci-field">
        <label htmlFor="email">Email:</label>
        <TextField
          id="email"
          type="email"
          value={data.email}
          onChange={(e) => handleChange('email', e.target.value)}
          fullWidth
        />
      </div>

      <div className="eci-field">
        <label htmlFor="phone">Τηλέφωνο:</label>
        <TextField
          id="phone"
          type="tel"
          value={data.phone}
          onChange={(e) => handleChange('phone', e.target.value)}
          fullWidth
        />
      </div>

      <div className="eci-field-full">
        <label htmlFor="address">Διεύθυνση:</label>
        <TextField
          id="address"
          value={data.address}
          onChange={(e) => handleChange('address', e.target.value)}
          fullWidth
        />
      </div>

      <div className="eci-field">
        <label htmlFor="city">Πόλη:</label>
        <TextField
          id="city"
          value={data.city}
          onChange={(e) => handleChange('city', e.target.value)}
          fullWidth
        />
      </div>

      <div className="eci-field">
        <label htmlFor="zipcode">Τ.Κ:</label>
        <TextField
          id="zipcode"
          value={data.zipcode}
          onChange={(e) => handleChange('zipcode', e.target.value)}
          fullWidth
        />
      </div>

      {/* Τρόπος Αποστολής */}

      <div className="eci-field-full">
        <FormControl>
          <FormLabel>Τρόπος Αποστολής</FormLabel>

          <RadioGroup
            value={data.shipping}
            onChange={(e) =>
              handleChange('shipping', e.target.value)
            }
          >
            <FormControlLabel
              value="courier"
              control={<Radio />}
              label="Courier (+3,00 €)"
            />

            <FormControlLabel
              value="storePickup"
              control={<Radio />}
              label="Παραλαβή από το κατάστημα (Δωρεάν)"
            />
          </RadioGroup>
        </FormControl>
      </div>

      {/* Τρόπος Πληρωμής */}

<div className="eci-field-full">
  <FormControl>
    <FormLabel>Τρόπος Πληρωμής</FormLabel>

    <RadioGroup
      value={data.payment}
      onChange={(e) =>
        handleChange('payment', e.target.value)
      }
    >

      <FormControlLabel
        value="cod"
        control={<Radio />}
        label="Αντικαταβολή (+2,00 €)"
      />

      <FormControlLabel
        value="bankTransfer"
        control={<Radio />}
        label="Τραπεζική κατάθεση (Δωρεάν)"
      />

      {data.payment === 'bankTransfer' && (
        <div className="bank-transfer-info">

          <div className="bank-account">
            <strong>ΠΕΙΡΑΙΩΣ:</strong>
            <span>
               GR97 0172 2510 0052 5110 8655 161
            </span>
          </div>

          <div className="bank-account">
            <strong>EUROBANK:</strong>
            <span>
              GR25 0260 1130 0001 5020 0267 114
            </span>
          </div>

          <div className="bank-account">
            <strong>ALPHA BANK:</strong>
            <span>
              GR82 0140 5140 5140 0200 2003 971
            </span>
          </div>

          <div className="bank-account">
            <strong>ΕΘΝΙΚΗ BANK:</strong>
            <span>
              GR26 0110 4490 0000 9101 4119 266
            </span>
          </div>

        </div>
      )}

      <FormControlLabel
        value="card"
        control={<Radio />}
        label="Πληρωμή με κάρτα"
      />
{/* 
      {data.payment === 'card' && (
        <DemoCardForm
          onValidityChange={onCardValidityChange}
        />
      )} */}

    </RadioGroup>
  </FormControl>
</div>

    </div>
  )
}